import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import CopilotControlHeader from './CopilotControlHeader/CopilotControlHeader'
import useCopilotControl from './useCopilotControl'
import NeedsAttention from './Widgets/NeedsAttention/NeedsAttention'
import NoAttentionRequired from './Widgets/NoAttentionRequired'
import PatientsSentiment from './Widgets/PatientsSentiment'
import PatientsWeContacted from './Widgets/PatientsWeContacted'
import ScanningSchedule from './Widgets/ScanningSchedule'
import ScansAttentionRatioGraph from './Widgets/ScansAttentionRatioGraph'
import TimeSaved from './Widgets/TimeSaved'
import TotalScans from './Widgets/TotalScans'

const useStyles = makeStyles(theme => ({
  root: props => ({
    background: '#F8F9FB',
    width: '100%',
    height: 'calc(100% - var(--app-header-v2-height))',
    padding: '0px 40px',
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      paddingBottom: 0
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: 0
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: 20
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: 40
    }
  }),
  widgetsContainer: {
    marginTop: 20,
    height: 'calc(100% - var(--app-header-v2-height) - 40px)'
  },
  scansAttentionRatioContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center'
  },
  engagementsContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

const CopilotControl = () => {
  const classes = useStyles()

  const {
    pastXDays,
    setPastXDays,
    isLoading,
    isUninitialized,
    timeSavedMinutes,
    totalScans,
    totalNeedsAttention,
    virtualCheckups,
    noAttentionRequired,
    patientsWeContacted,
    patientsWeSentBrushing,
    patientsWeSentChewies,
    sentimentScore = 9,
    scanningScore = 5,
    needsAttentionPatients = [],
    isNeedsAttentionPatientsLoading = false,
    practiceGuidelinesConfiguration = []
  } = useCopilotControl({})

  return (
    <Grid container className={classes.root} direction="column" wrap="nowrap">
      <Grid item>
        <CopilotControlHeader
          pastXDays={pastXDays}
          setPastXDays={setPastXDays}
          practiceGuidelinesConfiguration={practiceGuidelinesConfiguration}
        />
      </Grid>

      <Grid container id="copilot-widgets" wrap="nowrap" className={classes.widgetsContainer}>
        {/* FIRST COLUMN */}
        <Grid container direction="column" item xs={12} sm={3} md={3} lg={3} xl={3} style={{ height: '100%' }}>
          <Grid item>
            <TotalScans value={virtualCheckups} isLoading={isLoading || isUninitialized} />
          </Grid>
          <Grid item style={{ flexGrow: 1, display: 'flex' }}>
            <ScansAttentionRatioGraph
              isLoading={isLoading || isUninitialized}
              totalScans={totalScans}
              totalNeedsAttention={totalNeedsAttention}
            />
          </Grid>
          <Grid item>
            <NoAttentionRequired value={noAttentionRequired} isLoading={isLoading || isUninitialized} />
          </Grid>
          <Grid item>
            <TimeSaved timeSavedMinutes={timeSavedMinutes} isLoading={isLoading || isUninitialized} />
          </Grid>
        </Grid>
        {/* SECOND COLUMN */}
        <Grid container direction="column" item sm={3} md={3} lg={3} xl={3} style={{ height: '100%' }} wrap="nowrap">
          <Grid item>
            <PatientsWeContacted
              total={patientsWeContacted}
              forBrushing={patientsWeSentBrushing}
              forChewies={patientsWeSentChewies}
              isLoading={isLoading || isUninitialized}
            />
          </Grid>
          <Grid item className={classes.engagementsContainer}>
            <PatientsSentiment score={sentimentScore} isLoading={isLoading || isUninitialized} />
          </Grid>
          <Grid item className={classes.engagementsContainer}>
            <ScanningSchedule score={scanningScore} isLoading={isLoading || isUninitialized} />
          </Grid>
        </Grid>
        {/* THIRD COLUMN */}
        <Grid container direction="column" item sm={6} md={6} lg={6} xl={6} style={{ height: '100%' }} wrap="nowrap">
          <Grid item style={{ flexGrow: 1, height: '100%' }}>
            <NeedsAttention patients={needsAttentionPatients} isLoading={isNeedsAttentionPatientsLoading} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CopilotControl
